export interface AdditionalMaterialPayload {
  workOrderOperationId: string | null;
  sector: string;
  materialId: string;
  quantityPlanned: number;
  status: string;
  comment?: string;
}

export class Material {
  createdAt: string;
  materialId: string;
  nonStandardMaterialId: string;
  isApproved: boolean;
  isReserved: boolean;
  isReturned: boolean;
  isSelected: boolean;
  materialName: string;
  materialUnit: string;
  quantityPlanned: number;
  quantityConsumed: number;
  materialTotalQuantity: string;
  sector: string;
  updatedAt: string;
  firstDeadline: string;
  deadline: string;
  workOrderId: number;
  workOrderMaterialId: string;
  workRequestMaterialId: string;
  workOrders: Array<any>;
  comment: string;
  workOrderUpisId: string;
  workOrderName: string;
  unit: string;
  quantityIssued: number;
  quantityReturned: number;
  currentUnitPrice: number;
  currentUnitPriceEur: number;
  lockedPrice: number;
  lockedUnitPrice: number;
  currentPrice: number;
  isActive: boolean;
  isLocked: boolean;
  normativeValue: number;
  isStandard: boolean;
  quantityFromUpis: number;
  difference: number;
  minimumAllowedQuantity: number;
  isCustomPriceSet: boolean;
  customUnitPrice: number;

  constructor(material: any) {
    this.createdAt = material.createdAt || undefined;
    this.materialId = material.materialId || undefined;
    this.nonStandardMaterialId = material.nonStandardMaterialId || undefined;
    this.isApproved = material.isApproved || undefined;
    this.isReserved = material.isReserved || undefined;
    this.isReturned = material.isReturned || undefined;
    this.materialName = material.materialName || material.name || undefined;
    this.materialUnit = material.materialUnit || undefined;
    this.quantityPlanned = material.quantityPlanned || material.materialQuantity || material.plannedQuantity || undefined;
    this.quantityConsumed = material.quantityConsumed || undefined;
    this.materialTotalQuantity = material.materialTotalQuantity || undefined;
    this.sector = material.sector || material.materialSector || undefined;
    this.updatedAt = material.updatedAt || undefined;
    this.firstDeadline = material.firstDeadline || undefined;
    this.deadline = material.deadline || undefined;
    this.workOrderId = material.workOrderId || undefined;
    this.workOrderMaterialId = material.workOrderMaterialId || undefined;
    this.workRequestMaterialId = material.workRequestMaterialId || undefined;
    this.workOrders = material.workOrders || undefined;
    this.comment = material.comment || undefined;
    this.workOrderUpisId = material.workOrderUpisId || undefined;
    this.workOrderName = material.workOrderName || undefined;
    this.unit = material.unit || undefined;
    this.quantityIssued = material.quantityIssued || undefined;
    this.quantityReturned = material.quantityReturned || undefined;
    this.currentUnitPrice = material.currentUnitPrice || 0;
    this.currentUnitPriceEur = material.currentUnitPriceEur || 0;
    this.lockedPrice = material.lockedPrice || 0;
    this.lockedUnitPrice = material.lockedUnitPrice || 0;
    this.currentPrice = material.currentPrice || 0;
    this.isActive = material.isActive;
    this.isLocked = material.isLocked;
    this.normativeValue = material.normativeValue || 0;
    this.isStandard = material.isStandard || undefined;
    this.quantityFromUpis = material.quantityFromUpis || 0;
    this.difference = material.difference || 0;
    this.minimumAllowedQuantity = material.minimumAllowedQuantity || 0;
    this.isCustomPriceSet = material.isCustomPriceSet || undefined;
    this.customUnitPrice = material.customUnitPrice || 0;
  }
}
